import { useRoutes } from 'react-router-dom'
import MainRoutes from './RouteMain'
import RouteAuthentication from './RouteAuthentication'
import config from './../config/config'
import { useLocation } from 'react-router-dom'
import { getAccount, getSeller } from '../utility/Credentials'

const ThemeRoutes = () => {
  const location = useLocation()

  let routes = [RouteAuthentication]
  let seller_path = [
    '/account/signin',
    // '/store/register',
    '/store/account-request',
    '/store/account-rejected',
    '/store/account-deactivated',
    '/store/account-verified',
  ]

  let protected_path = []
  for (const [index, route] of MainRoutes.children.entries()) {
    protected_path.push({ index: index, path: route.path })
  }

  // ROUTE VALIDATION
  const main_path = protected_path.find((find) => find.path === location.pathname)
  const store_path = seller_path.find((find) => find === location.pathname)
  if ((main_path || store_path) && !getAccount() && location.pathname !== '/account/signin') {
    window.location = '/account/signin'
  } else {
    if (main_path && getAccount() && !getSeller()) {
      window.location = '/store/register'
    } else if (getAccount() && getSeller()?.status === 'ACTIVE' && !main_path && store_path) {
      window.location = '/'
    } else if (
      getAccount() &&
      getAccount().must_change_password === 'Y' &&
      getSeller()?.status === 'ACTIVE' &&
      location.pathname !== '/account/settings/password'
    ) {
      window.location = '/account/settings/password'
    } else if (getAccount() && getSeller()?.status === 'ACTIVE') {
      routes = [MainRoutes, RouteAuthentication]
    } else if (
      getAccount() &&
      getSeller()?.status === 'PENDING' &&
      location.pathname === '/store/account-verified'
    ) {
      routes = [RouteAuthentication]
    } else {
      if (
        location.pathname !== '/store/account-request' &&
        getAccount() &&
        getSeller()?.status === 'PENDING'
      ) {
        window.location = '/store/account-request'
      } else if (
        location.pathname !== '/store/account-rejected' &&
        getAccount() &&
        getSeller()?.status === 'REJECTED'
      ) {
        window.location = '/store/account-rejected'
      } else if (
        location.pathname !== '/store/account-deactivated' &&
        getAccount() &&
        getSeller()?.status === 'DEACTIVATED'
      ) {
        window.location = '/store/account-deactivated'
      }
    }
  }

  return useRoutes(routes, config.basename)
}

export default ThemeRoutes
